// Placeholder data until a real endpoint exists — see @doc/production-dashboard/people-tab-station-login-training-status
// (TASKS/IT-120046/p1/readpp.md). Shape mirrors the proposed API response so swapping to the real
// service call later is a one-line change in PeopleTab.js.
import { TRAINING_STATUS } from './peopleHelpers';

export const MOCK_STATION_LOGINS = [
  { userId: 1, userName: 'John Smith', stationId: 12, stationName: 'A Line - Welding', trainingStatus: TRAINING_STATUS.NONE },
  { userId: 2, userName: 'Alice Brown', stationId: 5, stationName: 'B Line - Cutting', trainingStatus: TRAINING_STATUS.NONE },
  { userId: 3, userName: 'Mark Wilson', stationId: 8, stationName: 'Glazing Bay 2', trainingStatus: TRAINING_STATUS.IN_PROGRESS },
  { userId: 4, userName: 'Sarah Lee', stationId: 3, stationName: 'Hardware Fitting', trainingStatus: TRAINING_STATUS.IN_PROGRESS },
  { userId: 5, userName: 'Tom Davies', stationId: 12, stationName: 'A Line - Welding', trainingStatus: TRAINING_STATUS.COMPLETED },
  { userId: 6, userName: 'Emily Clarke', stationId: 9, stationName: 'Despatch', trainingStatus: TRAINING_STATUS.NONE }
];
